// Comparateur — lit le bloc JSON rendu par Liquid, jamais le réseau.
(function () {
  'use strict';
  var hote = document.querySelector('[data-comparateur]');
  var bloc = document.getElementById('donnees-comparateur');
  if (!hote || !bloc) { return; }

  var donnees;
  try { donnees = JSON.parse(bloc.textContent); } catch (e) { return; }
  if (!donnees.familles || !donnees.familles.length) { return; }

  var MAX = 4;
  var params = new URLSearchParams(window.location.search);
  var familleDemandee = params.get('famille');
  var choisis = (params.get('produits') || '').split(',').filter(Boolean).slice(0, MAX);

  var famille = donnees.familles.filter(function (f) { return f.handle === familleDemandee; })[0]
             || donnees.familles[0];

  function url(handles) {
    var u = window.location.pathname + '?famille=' + encodeURIComponent(famille.handle);
    if (handles.length) { u += '&produits=' + handles.map(encodeURIComponent).join(','); }
    return u;
  }

  function texte(el, t) { el.textContent = t; return el; }
  function creer(tag, classe) { var e = document.createElement(tag); if (classe) { e.className = classe; } return e; }

  function dessiner() {
    hote.textContent = '';

    // Choix de la famille
    var barre = creer('div', 'comparateur__barre');
    var etiq = creer('label');
    etiq.setAttribute('for', 'comparateur-famille');
    texte(etiq, document.documentElement.lang === 'fr' ? 'Famille' : 'Family');
    var select = creer('select');
    select.id = 'comparateur-famille';
    donnees.familles.forEach(function (f) {
      var o = creer('option');
      o.value = f.handle; o.textContent = f.titre;
      if (f.handle === famille.handle) { o.selected = true; }
      select.appendChild(o);
    });
    select.addEventListener('change', function () {
      window.location.search = '?famille=' + encodeURIComponent(select.value);
    });
    barre.appendChild(etiq); barre.appendChild(select);
    hote.appendChild(barre);

    // Cases à cocher des produits
    var liste = creer('div', 'comparateur__choix');
    famille.produits.forEach(function (p) {
      var id = 'cmp-' + p.handle;
      var l = creer('label');
      var c = creer('input');
      c.type = 'checkbox'; c.id = id; c.value = p.handle;
      c.checked = choisis.indexOf(p.handle) !== -1;
      c.disabled = !c.checked && choisis.length >= MAX;
      c.addEventListener('change', function () {
        var suivants = c.checked ? choisis.concat([p.handle]) : choisis.filter(function (h) { return h !== p.handle; });
        window.location.href = url(suivants.slice(0, MAX));
      });
      l.appendChild(c);
      l.appendChild(texte(creer('span'), p.titre));
      liste.appendChild(l);
    });
    hote.appendChild(liste);

    var retenus = famille.produits.filter(function (p) { return choisis.indexOf(p.handle) !== -1; });
    if (retenus.length < 2) { return; }

    // Tableau accessible : en-têtes liés aux cellules, première colonne figée
    var cadre = creer('div', 'comparateur__cadre');
    var table = creer('table', 'comparateur__table');
    var thead = creer('thead');
    var tr = creer('tr');
    var vide = creer('th'); vide.scope = 'col'; tr.appendChild(vide);
    retenus.forEach(function (p) {
      var th = creer('th'); th.scope = 'col'; th.id = 'col-' + p.handle;
      var a = creer('a'); a.href = p.url; a.textContent = p.titre;
      th.appendChild(a);
      var prix = creer('div', 'comparateur__prix'); prix.textContent = p.prix;
      th.appendChild(prix);
      tr.appendChild(th);
    });
    thead.appendChild(tr); table.appendChild(thead);

    var tbody = creer('tbody');
    famille.champs.forEach(function (champ) {
      var valeurs = retenus.map(function (p) { return p.valeurs[champ.cle] || '—'; });
      var toutes = valeurs.join('|');
      var identiques = valeurs.every(function (v) { return v === valeurs[0]; });
      if (toutes.replace(/[—|]/g, '') === '') { return; }
      var ligne = creer('tr');
      var th = creer('th'); th.scope = 'row'; th.id = 'lig-' + champ.cle; th.textContent = champ.libelle;
      ligne.appendChild(th);
      valeurs.forEach(function (v, i) {
        var td = creer('td', identiques ? '' : 'comparateur__ecart');
        td.headers = 'lig-' + champ.cle + ' col-' + retenus[i].handle;
        td.textContent = v;
        ligne.appendChild(td);
      });
      tbody.appendChild(ligne);
    });
    table.appendChild(tbody);
    cadre.appendChild(table);
    hote.appendChild(cadre);
  }

  dessiner();
})();
